export default [
  {
    path: window.pathApp + '/pagamento/:slug',
    name: 'pagamento',
    component: () => import('@/components/Pagamento'),
    meta: {
      login: true,
      title: "Pagamento",
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/pagamento.js